import React from 'react';
import { string } from 'prop-types';
import { handleClick } from './utils';
import { IMAGES_PATH } from './constants';
import '../index.scss';

const renderTileImage = (id) => `${IMAGES_PATH}/${id}.svg`;
const NSC_PATH = 'nsc_tiles_carousel';

const NscTile = ({ id, alias, url, src }) => (
    <a href={url} className="tile box-shadow-z2" onClick={() => handleClick(NSC_PATH)}>
        <img src={src || renderTileImage(id)} alt={alias} loading="lazy"/>
        <p className="text-body-2">{alias}</p>
    </a>
);

NscTile.propTypes = {
    id: string,
    alias: string,
    url: string,
    src: string
};

export default NscTile;
